import { app } from '../../../../bootstrap/core';
import { cardFooterComponent } from './cardFooter.component';
import './contractingPartners/contractingPartners';
import './paymentPartnerEditing/paymentPartnerEditing';
import './contractPartnerCancellation/contractPartnerCancellation';

app.component('cardFooter', cardFooterComponent);
